import * as ss from 'superstruct';

export const TwilioVoiceConfig = ss.type({
  forwardingNumber: ss.string(),
  monthlySpendLimit: ss.optional(ss.number()),
});

export type TwilioVoiceConfig = ss.Infer<typeof TwilioVoiceConfig>;
